import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function MCPanelHeader({ label, meta, right, className = '', border = false, tight = false, flush = false, headingId, as = 'h2', }) {
    const title = label
        ? React.createElement(as, { id: headingId, className: 'mc-section-label' }, label)
        : null;
    return (_jsxs("div", { className: [
            'mc-panel-header',
            border ? 'mc-panel-header-bordered' : '',
            tight ? 'mc-panel-header-tight' : '',
            flush ? 'mc-panel-header-flush' : '',
            className,
        ]
            .filter(Boolean)
            .join(' '), children: [(title || meta || right) && (_jsxs("div", { className: "mc-panel-header-title", children: [title, meta && _jsx("div", { className: "mc-meta mt-1", children: meta })] })), right && _jsx("div", { className: "mc-panel-header-actions", children: right })] }));
}
export function MCSection({ label, right, children, className = '', borderless = false, panel = true }) {
    const panelCls = panel ? 'mc-panel' : '';
    return (_jsxs("section", { className: `${panelCls} ${className}`, children: [(label || right) && (_jsx(MCPanelHeader, { label: label, right: right, border: !borderless })), children] }));
}
